import React, { useState } from 'react';

import './Setup.lugarChange.scss';
import IconButton from '../Forms/IconButton';
import Input from '../Forms/Input';
import { FiscalpopProfile } from '../../models/Profile';
import { graphqlSchema } from '../../services/graphql.schema';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import { REGIMEN_OPTIONS } from '../../utils/regimen';
import Select from '../Forms/Select';
import { useMutation } from '@apollo/client';

const ZIP_REGEX = /\b[0-9]{5}\b/

function SetupLugarChange({ fiscalpopProfile }: { fiscalpopProfile: FiscalpopProfile }) {

    const [triedSubmitting, setTriedSubmitting] = useState(false);
    const [lugarExpedicion, setLugarExpedicion] = useState(!!fiscalpopProfile && fiscalpopProfile.lugarExpedicion? fiscalpopProfile.lugarExpedicion : '');
    const [regimen, setRegimen] = useState(!!fiscalpopProfile && fiscalpopProfile.regimenFiscal ? fiscalpopProfile.regimenFiscal : '');

    const [setLugar] = useMutation(graphqlSchema.PROFILE.SETUP.setLugarExpedicionChange, {
        onCompleted: ({ setLugarExpedicionChange }: {setLugarExpedicionChange: FiscalpopProfile}) => {
            console.log('Updated Lugar: ', setLugarExpedicionChange);
            setLugarExpedicion(setLugarExpedicionChange.lugarExpedicion);
            sharedToasterSubject.next({ type: 'confirm', message: `Se actualizó tu codigo postal de emisor` });
        },
        onError: (e) => {
            console.error('Error updating defaults: ', e);
        }
    })

    const setNewLugar = () => {
        if(!ZIP_REGEX.test(lugarExpedicion)){
            setTriedSubmitting(true);
            return;
        }

        setLugar({
            variables: {
                lugarExpedicion,
                regimenFiscal: regimen
            }
        })
    }

    return (
        <div className="card lugarChange" id="SetupLugarChange">
            <div className="title">
                <IconButton primary={true} handleClick={setNewLugar}>
                    <i className="material-icons">
                        save
                    </i>
                </IconButton>

            </div>
            <div className="lugarWrap">
                <Input type="text" hasError={triedSubmitting && !ZIP_REGEX.test(lugarExpedicion)} value={lugarExpedicion} onChange={setLugarExpedicion} placeholder="Código postal de tu empresa" label={'Código postal de tu empresa'} />
                
                <Select value={regimen} onChange={setRegimen} placeholder="Régimen de tu empresa" label={'Régimen'} options={REGIMEN_OPTIONS}/>
            </div>
        </div>
    )
}

/*

*/

export default SetupLugarChange;